'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';

import { getVariantFirstLoad } from '../../actions/get-variant-first-load/get-variant-first-load';

export default function MedicariansBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    getVariantFirstLoad('mp-1324_medicarians_homepage_banner').then((data) => {
      setVisible(data === 'on');
    });
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="bg-secondary-50 py-12-12 text-center font-bold">
      🎉 Autopilot by Healthcare.com is a proud sponsor of Medicarians.{' '}
      <Link
        href="https://www.healthcare.com/partners/medicarians-2025"
        target="_blank"
      >
        Click to learn more.
      </Link>
    </div>
  );
}
